import React, { useEffect, useState } from "react";
import axios from "axios";
import { HR, card } from "@/lib/hr";

const TONE = { AL: "bg-emerald-500/30 text-emerald-100", MC: "bg-rose-500/30 text-rose-100", HL: "bg-rose-600/40 text-rose-100", UL: "bg-slate-500/30 text-slate-100", FL: "bg-sky-500/30 text-sky-100", CL: "bg-violet-500/30 text-violet-100", LV: "bg-amber-500/30 text-amber-100" };

// Monthly grid of approved leave — a visual HR tool only
export function LeaveCalendar({ month }) {
  const [data, setData] = useState(null);
  useEffect(() => { setData(null); axios.get(`${HR}/leave/calendar`, { params: { month } }).then(({ data }) => setData(data)).catch(() => setData({ days: [], employees: [], cells: {}, legend: {} })); }, [month]);
  if (!data) return <div className="text-slate-500 text-sm">Loading…</div>;
  const dow = (iso) => new Date(`${iso}T00:00:00`).getDay();
  return (
    <div className={`${card} overflow-x-auto`} data-testid="leave-calendar">
      <table className="text-xs border-collapse min-w-full">
        <thead>
          <tr className="text-[10px] uppercase tracking-wider text-slate-500">
            <th className="sticky left-0 bg-[#151D2E] text-left px-3 py-2 min-w-[160px]">Employee</th>
            {data.days.map((iso) => <th key={iso} className={`px-1 py-2 font-mono-num min-w-[30px] ${dow(iso) === 0 || dow(iso) === 6 ? "text-slate-600" : ""}`}>{iso.slice(8)}</th>)}
          </tr>
        </thead>
        <tbody>
          {data.employees.length === 0 && <tr><td colSpan={data.days.length + 1} className="px-3 py-8 text-center text-slate-500">No employees.</td></tr>}
          {data.employees.map((e) => (
            <tr key={e.id} className="border-t border-white/[0.05]" data-testid={`cal-row-${e.id}`}>
              <td className="sticky left-0 bg-[#151D2E] px-3 py-1.5 whitespace-nowrap"><span className="font-semibold">{e.full_name}</span> <span className="text-slate-500 font-mono-num">{e.employee_id}</span></td>
              {data.days.map((iso) => { const c = data.cells[e.id]?.[iso]; const wk = dow(iso) === 0 || dow(iso) === 6; return <td key={iso} title={c ? `${c.type} · ${iso}` : iso} className={`p-0.5 text-center ${wk && !c ? "bg-white/[0.02]" : ""}`}>{c ? <span className={`block rounded px-0.5 py-1 font-bold ${TONE[c.code] || TONE.LV}`}>{c.code}</span> : <span className="block py-1 text-slate-700">·</span>}</td>; })}
            </tr>
          ))}
        </tbody>
      </table>
      <div className="flex flex-wrap gap-3 px-3 py-2 border-t border-white/[0.05] text-[10px] text-slate-400">{Object.entries(data.legend).map(([t, c]) => <span key={c} className="inline-flex items-center gap-1"><span className={`rounded px-1 font-bold ${TONE[c] || TONE.LV}`}>{c}</span>{t}</span>)}</div>
    </div>
  );
}
